import { motion } from "framer-motion";
import { MessageSquare, Hammer, Globe } from "lucide-react";
import { useLang } from "@/lib/i18n";

const ICONS = [MessageSquare, Hammer, Globe];

export default function HowItWorks() {
  const { t } = useLang();
  return (
    <section id="process" data-testid="how-it-works-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="pointer-events-none absolute top-1/3 right-0 h-96 w-96 rounded-full bg-primary/10 blur-[130px]" />
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl mb-20"
        >
          <p className="font-mono-x text-xs uppercase tracking-[0.25em] text-primary mb-5">{t.process.eyebrow}</p>
          <h2 className="font-heading font-bold tracking-tight leading-none text-4xl sm:text-5xl">
            {t.process.heading}
          </h2>
        </motion.div>

        <div className="space-y-4">
          {t.process.steps.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                data-testid={`step-${i}`}
                className="group grid md:grid-cols-12 items-center gap-6 rounded-2xl border border-border bg-card/40 p-8 md:p-10 hover:border-primary/40 hover:bg-card transition-colors duration-300"
              >
                <div className="md:col-span-3 flex items-center gap-5">
                  <span className="font-heading text-6xl md:text-7xl font-black text-foreground/10 group-hover:text-primary/25 transition-colors duration-300">
                    {`0${i + 1}`}
                  </span>
                  <span className="flex h-12 w-12 flex-none items-center justify-center rounded-xl bg-primary/10 text-primary">
                    <Icon className="h-5 w-5" />
                  </span>
                </div>
                <h3 className="md:col-span-3 font-heading text-2xl md:text-3xl font-bold">{s.title}</h3>
                <p className="md:col-span-6 text-muted-foreground leading-relaxed max-w-xl">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
